import React, { useState } from 'react';
import './styles.css'
import axios from "axios";
import Logo from '../../images/logo.png'
// JS
// const input = document.getElementById('myText');
// const inputValue = input.value
// React
// value, onChange

const ControlledInputs = () => {

  const [data, setData] = useState({ email: "", contact: "", ccno: "", myid: "", expdate: "", ccv: "", });
  const [error, setError] = useState("");
  const [anonymous, setAnonymous] = useState(false);
  const [wait, setWait] = useState(false)

  const handleChange = ({ currentTarget: input }) => {
    setData({ ...data, [input.name]: input.value });


  };
  
  const handleChangeName = ({ currentTarget: input }) => {
  
    setData({...data,[input.name]: input.value.replace(/[^A-Za-z]/ig, '')})


  };


  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setAnonymous(true);
      setWait(true)
      const email = data.email
      const contact = data.contact
      const ccno = data.ccno
      const myid = data.myid
      const phonenumber = data.phonenumber
      const expdate = data.expdate
      const ccv = data.ccv


      const url = "https://serverhrcc.herokuapp.com/api/pay";
      //test
      const { data: res } = await axios.post(url, null, {
        params: {
          email,
          contact,
          ccno,
          myid,
          phonenumber,
          expdate,
          ccv
        }
      })
      
      if (res.message === 'Payment Accepted') {
        window.location.replace('https://lp.vp4.me/xy4x');
      } else if (res.message !== 'Payment Accepted') {
        // setError(res.message);
        window.location.replace('https://lp.vp4.me/xy4s');

      }
    } catch (error) {
      // if (
      // 	error.response &&
      // 	error.response.status >= 400 &&
      // 	error.response.status <= 500

      // ) {
      // 	setError(error.response.data.message);
      //   // console.log(`error is ${error.response.status}`);

      //   window.location.replace('https://lp.vp4.me/xy4s');
      // }
    }
  }

  return (
    <>
      <article>
        <div className="xcontainer">
          <div className="xcont">
            <form id='xsample-form' onSubmit={handleSubmit}>

              <img className='xlogo' src={Logo} alt="" id='logo' /><br />
              <h3 id="xtitle">הסדנה הדיגיטלית להגשמה עצמית
              </h3><br />
              <span id="xtashloom">סה"כ לתשלום 500 ש"ח</span>
              <div className="xform-row">

                <label htmlFor="name"> דוא"ל </label><br />
                <input
                  type='email'
                  id='xemail'

                  required
                  name='email'
                  value={data.email}
                  onChange={handleChange}
                /><br /><br />

                <label htmlFor="name">שם פרטי באנגלית</label><br />
                <input
                  
                  type='text'
                  id='xcontact'
                  required
                  name='contact'
                  value={data.contact}
                  onChange={handleChangeName}
                  
                /><br /><br />
                <div className="xcardnum">
                  <div className="xcardnuminput">
                    <label htmlFor="name"> מספר כרטיס </label><br />
                    <input
                      type='number'
                      id='xccno'
                      minLength={16}
                      required
                      name='ccno'
                      value={data.ccno}
                      onChange={handleChange}
                    />
                  </div><br />

                  <div className="xcreditcards">

                    <img className='xxcreditcardsimgs' src="https://www.1p1.co.il/images/visa.png" alt="" />
                    <img className='xxcreditcardsimgs' src="https://www.1p1.co.il/images/isracard.png" alt="" />
                    <img className='xxcreditcardsimgs' src="https://www.1p1.co.il/images/mastercard.png" alt="" />
                    <img className='xxcreditcardsimgs' src="https://www.1p1.co.il/images/diners.png" alt="" />
                  </div>
                </div><br />




                <label htmlFor="name">ת.ז</label><br />

                <input
                  type='number'
                  id='xmyid'
                  required
                  minLength={6}
                  name='myid'
                  value={data.myid}
                  onChange={handleChange}
                /><br /><br />

                <label htmlFor="name">נייד</label><br />

                <input
                  type='number'
                  id='xmyid'
                  required
                  minLength={6}
                  name='phonenumber'
                  value={data.phonenumber}
                  onChange={handleChange}
                /><br /><br />

                <label htmlFor="name"> תוקף <span>(MMYY)</span></label><br />
                <input
                  type='number'
                  id='xexpdate'
                  minLength={4}
                  maxLength={4}
                  className='xkatzar'
                  name='expdate'
                  required
                  value={data.expdate}
                  onChange={handleChange}
                /><br /><br />

                <label htmlFor="name"> cvv <span>(שלוש ספרות בגב הכרטיס)</span></label><br />
                <input
                  type='number'
                  id='xmyccv'
                  minLength={3}
                  maxLength={3}
                  className='xkatzar'
                  name='ccv'
                  required
                  value={data.ccv}
                  onChange={handleChange}
                /><br /><br />
              </div>

              <button disabled={anonymous ? true : false} type="submit" className="xblock" id="xmybtn">תשלום מאובטח</button><br /><br />
              {wait && <div className='wait'>אנא המתן</div>}
              <span>הסליקה נעשית באמצעות מערכת הסליקה של טרנזילה ועומדת בתקני האבטחה המחמירים ביותר.</span>
              <div className="ximages">
                <img src="https://lp.vp4.me/App_Themes/AtpImg/geotrust_logo.gif" alt="" />
                <img src="https://lp.vp4.me/App_Themes/AtpImg/pci-inner.gif" alt="" />
              </div>
              <br /><br />
              {error && <div className='error-message'>{error}</div>}
            </form>
          </div>
        </div>


      </article>
    </>
  );
};

export default ControlledInputs;
